module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp3_5012.c11a6d96.png";